import Reveal from "@/components/base/Reveal";
import { rankingData } from "@/mocks/home";

const coverMeta = [
  { label: "投稿身份", value: "可选匿名" },
  { label: "响应时效", value: "30 分钟内" },
  { label: "受理时间", value: "7×24" },
];

export default function Hero() {
  const hotList = rankingData.week.slice(0, 3);

  return (
    <section id="entry" className="relative bg-background-50 pb-16 pt-24 md:pb-24 md:pt-32">
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-8">
        <div className="grid grid-cols-1 gap-3 md:gap-5 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <article className="relative flex min-h-[440px] flex-col justify-end overflow-hidden rounded-lg border border-background-200/70 bg-foreground-950 p-6 md:min-h-[540px] md:p-10">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20magazine%20cover%20artwork%20with%20torn%20kraft%20paper%20collage%20in%20warm%20terracotta%2C%20espresso%20brown%20and%20soft%20cream%20tones%2C%20fine%20grain%20texture%20and%20subtle%20ink%20stains%2C%20soft%20diffused%20north%20light%20casting%20gentle%20shadows%2C%20minimal%20layered%20composition%20with%20generous%20negative%20space%2C%20muted%20earthy%20palette%2C%20fine%20art%20print%20aesthetic%20with%20no%20text%2C%20high%20detail&width=1200&height=860&seq=hl-hero-01&orientation=landscape"
                alt="黑料投稿匿名入口杂志封面视觉"
                title="黑料投稿匿名入口 安全私密提交"
                className="absolute inset-0 h-full w-full object-cover object-top opacity-75"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/75 to-foreground-950/15" />

              <div className="relative">
                <span className="font-label text-xs uppercase tracking-[0.4em] text-accent-300">
                  Anonymous Tips · Confidential
                </span>
                <h2 className="mt-4 font-heading text-3xl leading-tight text-background-50 md:text-5xl">
                  黑料投稿，从一个安全的匿名入口开始
                </h2>
                <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-100/90 md:text-base">
                  提供黑料投稿的匿名入口与联系方式，支持私信、邮箱及在线表单安全提交。全程保护投稿人隐私，快速响应审核，确保信息直达。无论您掌握何种线索，均可通过本渠道匿名分享，我们承诺严格保密。
                </p>

                <div className="mt-7 flex flex-col gap-3 sm:flex-row">
                  <a
                    href="#channels"
                    className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
                  >
                    查看投稿方式
                    <i className="ri-arrow-right-line" />
                  </a>
                  <a
                    href="#privacy"
                    className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 font-label text-sm text-background-50 transition-colors hover:bg-background-50/10 cursor-pointer"
                  >
                    隐私保护承诺
                  </a>
                </div>

                <dl className="mt-8 flex flex-wrap gap-x-10 gap-y-4 border-t border-background-50/20 pt-6">
                  {coverMeta.map((item) => (
                    <div key={item.label}>
                      <dt className="font-label text-[11px] uppercase tracking-[0.2em] text-background-100/60">
                        {item.label}
                      </dt>
                      <dd className="mt-1 font-heading text-base text-background-50">{item.value}</dd>
                    </div>
                  ))}
                </dl>
              </div>
            </article>
          </Reveal>

          <div className="grid grid-cols-1 gap-3 md:gap-5 sm:grid-cols-2 lg:col-span-5 lg:grid-cols-1">
            <Reveal delay={80} className="h-full">
              <article className="flex h-full flex-col justify-between rounded-lg border border-background-200/70 bg-secondary-50 p-6 md:p-8">
                <div>
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className="ri-shield-keyhole-line text-xl" />
                  </span>
                  <h3 className="mt-5 font-heading text-xl text-foreground-950">
                    黑料投稿匿名入口
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                    无需注册账号，选择任意一种匿名投稿渠道即可开始，提交完成后自动生成随机查询码，方便后续核对进度。
                  </p>
                </div>
                <a
                  href="#channels"
                  className="mt-6 inline-flex items-center gap-2 font-label text-sm text-primary-600 transition-colors hover:text-primary-700 cursor-pointer"
                >
                  前往匿名入口
                  <i className="ri-arrow-right-line" />
                </a>
              </article>
            </Reveal>

            <Reveal delay={160} className="h-full">
              <article className="flex h-full flex-col rounded-lg border border-background-200/70 bg-background-100 p-6 md:p-8">
                <div className="flex items-center justify-between">
                  <span className="font-label text-xs uppercase tracking-[0.3em] text-foreground-500">
                    热度榜
                  </span>
                  <a
                    href="#ranking"
                    className="font-label text-xs text-primary-600 transition-colors hover:text-primary-700 cursor-pointer"
                  >
                    查看全部
                  </a>
                </div>
                <ol className="mt-6 space-y-5">
                  {hotList.map((item) => (
                    <li key={item.rank} className="flex items-start gap-4">
                      <span className="font-heading text-2xl leading-none text-accent-500">
                        {String(item.rank).padStart(2, "0")}
                      </span>
                      <span className="flex flex-col">
                        <span className="font-label text-sm text-foreground-900">{item.title}</span>
                        <span className="mt-1 font-label text-xs text-foreground-500">
                          热度 {item.heat} · {item.delta}
                        </span>
                      </span>
                    </li>
                  ))}
                </ol>
              </article>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}